<div mat-dialog-title class="modal-title">
  <mat-icon>format_list_bulleted</mat-icon>
  <span>Links del afiliado: {{ fullname }}</span>
  <mat-icon class="close-button" (click)="closeModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  @if (!links.length) {
    <div class="no-current"> No hay links disponibles </div>
  } @else {
    <div class="list">
      <div class="filter">
        <mat-form-field appearance="outline" color="primary">
          <mat-label>Buscar un producto</mat-label>
          @if (isSearchingProduct) {
            <mat-spinner matSuffix> </mat-spinner>
          }
          <input matInput name="productToSearch" placeholder="Nombre del producto" autocomplete="off" (keyup)="filterProductDebounced($event)" />
        </mat-form-field>
      </div>

      @if (!filteredLinks.length) {
        <div class="no-filter"> No hay productos que coincidan con tu búsqueda </div>
      } @else {
        <div>
          @for (link of filteredLinks; track link) {
            <div class="item">
              <span>
                {{ link.product }}
              </span>
              <button mat-icon-button color="primary" (click)="copyProductUrl(link.url)">
                <mat-icon>link</mat-icon>
              </button>
            </div>
          }
        </div>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button color="primary" (click)="closeModal()"> Cerrar </button>
</mat-dialog-actions>
